const messages = {
  IS_REQUIRED: (name) => `${name} Is Required`
};

export default messages;
